import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

import { pluginShape } from '../helpers/propTypes';

const EntityPickerModalEmptyState = ({ canCreate, onCreateClick, plugin }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const { CreateNewButtonText } = plugin;
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
      description={T.translate('NO_DATA')}
    >
      {canCreate && (
        <LinkButton onClick={onCreateClick}>
          {CreateNewButtonText ? (
            <CreateNewButtonText />
          ) : (
            T.translate('CREATE')
          )}
        </LinkButton>
      )}
    </EmptyState>
  );
};

EntityPickerModalEmptyState.propTypes = {
  /**
   * The plugin to use for selected entity type.
   */
  plugin: pluginShape,
  /**
   * Whether the user can create entity of selected type.
   */
  canCreate: PropTypes.bool.isRequired,
  /**
   * Callback when clicking create button
   */
  onCreateClick: PropTypes.func.isRequired,
};

export default EntityPickerModalEmptyState;
